import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Step, Stepper } from './Stepper'
import { CloseIcon } from '../../app/features/icons/Close'
import { FullLogo } from '../../app/features/icons/FullLogo'

import { TaskStatus } from '@/modules/shared/components'
import { HOME_ROUTES } from '@/modules/home/routes-typed'
import { useConfirm } from '@/modules/shared/context/ConfirmContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { CurrentDetailedDate } from '@/app/features/common/CurrentDetailedDate'

export const CreatorLayout = ({
  steps,
  children,
  monthLabel,
  onStepClick,
}: {
  steps: Step[]
  children: React.ReactNode
  monthLabel?: string
  onStepClick?: (id: string | number) => void
}) => {
  const navigate = useNavigate()
  const { companyId } = useParams<{ companyId: string }>()
  const confirm = useConfirm()
  const { tSafe } = useLocalize()

  const handleClose = async () => {
    const ok = await confirm({
      title: tSafe(
        'creator.close-confirm-title',
        'Czy na pewno chcesz wyjść?',
      ),
      message: tSafe(
        'creator.close-confirm-message',
        'Wprowadzone zmiany zostaną utracone.',
      ),
      confirmText: tSafe('answer.yes', 'Tak'),
      cancelText: tSafe('answer.cancel', 'Anuluj'),
    })
    if (!ok) return
    if (!companyId) {
      navigate('/')
      return
    }
    navigate(HOME_ROUTES.dashboard.buildPath({ companyId }))
  }
  return (
    <section className="tw-flex tw-flex-1  tw-flex-col tw-overflow-hidden tw-font-primary">
      <div className="tw-absolute tw-right-0 tw-top-0 tw-z-[101]">
        <TaskStatus />
      </div>
      <div className="tw-w-full tw-p-1 tw-text-content-base">
        <header className="tw-flex tw-h-14 tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-base-300 tw-bg-base-100 tw-p-3">
          <FullLogo className="tw-h-7 tw-w-[150px]" />
          <CurrentDetailedDate />
        </header>
      </div>
      <div className="tw-flex tw-w-full tw-flex-1 tw-min-h-0 tw-text-content-base">
        <div className="tw-hidden tw-w-full tw-max-w-[200px] lg:tw-block ">
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-6 tw-pb-4 tw-pl-4 tw-pr-6 tw-pt-3">
            <button
              type="button"
              onClick={handleClose}
              className="tw-flex tw-h-10 tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-2xl tw-bg-base-100 tw-shadow-drop"
            >
              <CloseIcon className="tw-w-20" />
            </button>
            {monthLabel && (
              <p className="tw-text-xl tw-font-semibold tw-text-content-base">
                {monthLabel}
              </p>
            )}
          </div>
          <div className="tw-flex tw-gap-1.5 tw-border-t tw-border-t-secondary tw-pb-11 tw-pl-4 tw-pr-3 tw-pt-8">
            <Stepper steps={steps} onStepClick={onStepClick} />
          </div>
        </div>
        <div className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-px-1 tw-py-3">
          {children}
        </div>
      </div>
    </section>
  )
}
